
  import { Component, Vue } from 'vue-property-decorator'
  import { Tour, TourOptions } from '@/plugins/tour'
  import { WelcomeTour } from '@/plugins/tour/examples/WelcomeTour'
  import { FinancerWelcomeTour } from '@/plugins/tour/examples/FinancerWelcomeTour'

@Component({
  components: {
    Tour,
  },
})
  export default class GlobalTour extends Vue {
  // Tour activo actualmente
  activeTour: any = null;

  // Opciones generales para tours
  tourOptions: TourOptions = {
    showButtons: true,
    showProgress: true,
    showCloseButton: true,
    darkMode: false,
    backdropOpacity: 0.7,
  };

  /**
   * Inicia un tour específico
   * @param tour Tour a iniciar
   */
  startTour (tour: any): void {
    if (!tour || !tour.id) {
      console.error('❌ Tour inválido:', tour)
      return
    }

    // Asignar el tour activo - esto activará el watcher del componente Tour
    this.activeTour = tour
  }

  /**
   * Inicia el tour de bienvenida
   */
  startWelcomeTour (): void {
    this.startTour(WelcomeTour)
  }

  /**
   * Inicia el tour de bienvenida específico para financer
   */
  startFinancerWelcomeTour (): void {
    this.startTour(FinancerWelcomeTour)
  }

  /**
   * Finaliza el tour actual
   */
  endTour (): void {
    if (this.$refs.globalTour) {
      (this.$refs.globalTour as any).end()
      this.activeTour = null
    }
  }

  /**
   * Obtiene referencia al componente de tour
   */
  getTourComponent (): any {
    return this.$refs.globalTour
  }
  }
